export default __webpack_public_path__ + "static/media/screenshot3_sm.c648dade.jpg";